/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ApplePaymentSignatureBase
 * auto generated base class for the model ApplePaymentSignatureModel.
 */
export const ApplePaymentSignatureModelBase = ModelBase.named('ApplePaymentSignature')
  .props({
    __typename: types.optional(types.literal('ApplePaymentSignature'), 'ApplePaymentSignature'),
    keyIdentifier: types.union(types.undefined, types.string),
    nonce: types.union(types.undefined, types.string),
    signature: types.union(types.undefined, types.string),
    timestamp: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ApplePaymentSignatureModelSelector extends QueryBuilder {
  get keyIdentifier() {
    return this.__attr('keyIdentifier')
  }
  get nonce() {
    return this.__attr('nonce')
  }
  get signature() {
    return this.__attr('signature')
  }
  get timestamp() {
    return this.__attr('timestamp')
  }
}
export function selectFromApplePaymentSignature() {
  return new ApplePaymentSignatureModelSelector()
}

export const applePaymentSignatureModelPrimitives =
  selectFromApplePaymentSignature().keyIdentifier.nonce.signature.timestamp
